import React, { useContext } from 'react';
import {
  GrievanceLogbookItem,
  GrievancePhase,
  GrievancePhaseDataApply,
} from '../../../../services/types/Grievance';
import GrievanceMilestoneListRow from './GrievanceMilestoneListRow';
import Context from '../context/DetailsContext';

interface Props {
  onPhaseApply: (grievancePhase: GrievancePhase, dataApply: GrievancePhaseDataApply) => void;
  onRemoveComment: (commentId: number, messageSuccess?: string) => void;
  onSaveLogbookItem: (logbookItem: GrievanceLogbookItem, messageSuccess?: string) => void;
  isReadOnly: boolean;
}

const GrievancePhases: React.FC<Props> = (props) => {
  const { onPhaseApply, onRemoveComment, onSaveLogbookItem, isReadOnly } = props;

  const { phases } = useContext(Context);

  const registrationDate = phases && phases.length > 0 ? phases[0].milestones[0].date : null;

  const renderPhases = () =>
    phases.map((x, i) => (
      <GrievanceMilestoneListRow
        key={`phaseRow${i.toString()}`}
        phase={x}
        registrationDate={registrationDate!}
        onPhaseApply={onPhaseApply}
        onRemoveComment={onRemoveComment}
        onSaveLogbookItem={onSaveLogbookItem}
        isReadOnly={isReadOnly}
      />
    ));

  return <div className="grievance-phases-list mt-2">{renderPhases()}</div>;
};

export default GrievancePhases;
